import axios from 'axios';
import { message } from 'ant-design-vue'
import router from "../router";
import store from "../store"
import qs from 'qs';
import config from '../config';

axios.defaults.timeout = 5000;
axios.defaults.baseURL = config.hostRoot; //填写域名



//http request 拦截器
axios.interceptors.request.use(
    config => {
        if (config.method == "post") {
            // config.data = JSON.stringify(config.data);
            // config.headers['Content-Type'] = 'application/json;charset=UTF-8';
            config.data = qs.stringify(config.data);
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        config.headers['x-auth-token'] = store.state.token;
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);


//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                console.log('错误请求')
                break;
            case 401:
                console.log('未授权，请重新登录')
                break;
            case 403:
                //console.log('拒绝访问')
                message.error("账号未登录或无权限访问")
                router.push({ path: "/login" })
                break;
            case 404:
                console.log('请求错误,未找到该资源')
                break;
            case 405:
                console.log('请求方法未允许')
                break;
            case 408:
                console.log('请求超时')
                break;
            case 500:
                console.log('服务器端出错')
                break;
            case 501:
                console.log('网络未实现')
                break;
            case 502:
                console.log('网络错误')
                break;
            case 503:
                console.log('服务不可用')
                break;
            case 504:
                console.log('网络超时')
                break;
            case 505:
                console.log('http版本不支持该请求')
                break;
            default:
                console.log(`连接错误${err.response.status}`)
        }
    } else {
        //console.log('连接到服务器失败')
        message.error("连接到服务器失败")
    }
    return Promise.resolve(err.response)
})


const encodeForm = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
        .join('&');
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(response => {
                const data = response.data;
                if (data.code != 200) {
                    console.log("发生错误")
                }
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function login(url, data) {
    return new Promise((resolve, reject) => {

        axios.get(url, data, {})
            .then(response => {
                console.log("response:")
                console.log(response)
                const token = response.headers['x-auth-token']
                store.commit('setToken', token)
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */


export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 下面是获取数据的接口
 */
export const server = {
    login: function(url, params) {
        return login(url, params);
    },
    logout: function() {
        store.commit('setToken', null)
        return fetch('/api/1.0/logout', {});
    },
    get: function(url, params) {
        return fetch(url, params);
    },

    post: function(url, params) {
        return post(url, params);
    },

    initParams: function(pagination, filters, sorter, query) {
        const pager = {...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        let json = {
            pageSize: pagination == null || pagination.pageSize == null ? 10 : pagination.pageSize,
            pageNo: pagination == null || pagination.current == null ? 1 : pagination.current,
            sortName: sorter == null || sorter.field == null ? null : sorter.field,
            sortOrder: sorter == null || sorter.order == null ? 'asc' : sorter.order,
        }
        for (let f in filters) {
            json[f] = filters[f][0]
        }
        for (let f in query) {
            json[f.replace(/_/g, "-")] = query[f]
        }
        return json;
    },

    ajaxResultDue(res, path, msg) {
        if (res.code === 200 && path != null) {
            router.push({ path: path })
        } else {
            if (null == msg) {
                msg = "操作不成功！"
            }
            if (res.code === 0) {
                msg = res.msg
            }
            message.error(msg);
        }
    }

}